var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('settings-control',{attrs:{"label":"Line Height"}},[_c('dropdown',{attrs:{"theme":"minimalistic","placeholder":"Select Size","options":_vm.options,"value":_vm.lineHeight,"native":""},on:{"input":_vm.onInput}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }